import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiMapPin, FiTrendingUp, FiTrendingDown, FiMinus, FiExternalLink } from 'react-icons/fi';

const CityCard = ({ city }) => {
  const getAlertColor = (level) => {
    switch (level) {
      case 'alert': return 'bg-red-100 border-red-500 text-red-800';
      case 'watch': return 'bg-yellow-100 border-yellow-500 text-yellow-800';
      default: return 'bg-green-100 border-green-500 text-green-800';
    }
  };

  const getAlertIcon = (level) => {
    switch (level) {
      case 'alert': return '🔴';
      case 'watch': return '🟡';
      default: return '🟢';
    }
  };

  const getTrendIcon = (trend) => {
    if (trend > 0) return <SafeIcon icon={FiTrendingUp} className="text-red-500" />;
    if (trend < 0) return <SafeIcon icon={FiTrendingDown} className="text-blue-500" />;
    return <SafeIcon icon={FiMinus} className="text-gray-400" />;
  };

  return (
    <div className={`bg-white rounded-lg shadow-md border-l-4 ${getAlertColor(city.alertLevel).split(' ')[1]} hover:shadow-lg transition-shadow`}>
      <div className="p-6">
        <div className="flex justify-between items-start mb-4">
          <div>
            <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
              <SafeIcon icon={FiMapPin} className="text-gray-500" />
              {city.name}
            </h3>
            <p className="text-sm text-gray-600">{city.region}</p>
          </div>
          <span className={`px-2 py-1 rounded-full text-xs font-medium border ${getAlertColor(city.alertLevel)}`}>
            {getAlertIcon(city.alertLevel)} {city.alertLevel.toUpperCase()}
          </span>
        </div>

        <div className="space-y-3">
          <div className="flex justify-between items-center">
            <span className="text-sm text-gray-600">Sea Temperature</span>
            <div className="flex items-center gap-2">
              <span className="text-2xl font-bold text-blue-600">
                {city.temperature ? `${city.temperature.toFixed(1)}°C` : 'N/A'}
              </span>
              {city.trend && getTrendIcon(city.trend)}
            </div>
          </div>

          {city.waveHeight && (
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Wave Height</span>
              <span className="text-sm font-medium">{city.waveHeight.toFixed(1)}m</span>
            </div>
          )}

          {city.lastReading && (
            <div className="text-xs text-gray-500">
              Reading: {new Date(city.lastReading).toLocaleString('en-PH')}
            </div>
          )}
        </div>

        <div className="mt-4 pt-4 border-t border-gray-100">
          <Link
            to={`/city/${city.id}`}
            className="flex items-center justify-center gap-2 w-full py-2 text-blue-600 hover:text-blue-800 transition-colors"
          >
            View Details
            <SafeIcon icon={FiExternalLink} className="text-sm" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CityCard;